import Vue from "vue";
import Vuetify from "vuetify/lib/framework";

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    dark: false,
    themes: {
      light: {
        primary: "#007DFF",
        success: "#72C270",
        info: "#ffaa2c",
        error: "#FF667A",
        secondary: "#F5FBFF",
        white: "#fff",
        grey1: "#969FA3",
        grey2: "#70777A",
        grey3: "#494949",
        black: "#000",
        hover: "#006BDA",
        textfield: "#4da4ff",
        cardText: "#333333",
        cardTextAccent1: "#004CA6",
        cardTextAccent2: "#B26500",
        cardTextAccent3: "#A60073",
        cardTextAccent4: "#00663D",
        transact: "#00CC66",
        level1: "#00BFA5",
        level2: "#ffaa2c",
        level3: "#FF6347",
        tint1: "#cce5ff",
        tint2: "#e6f2ff",
      },
      dark: {
        primary: "#ffaa2c",
        secondary: "#616161",
        accent: "#FFC107",
      },
    },
    options: {
      customProperties: true,
    },
    typography: {
      fontFamily: "Inter, sans-serif", // Use 'Inter' as the font name
    },
  },
});
